<template>
  <vs-card>
    <div slot="header">
      <h3>Veículos na base</h3>
    </div>
    <div v-if="listVeiculos.length == 0">
      <vs-alert style="height: auto" active="true" color="danger">
        Nenhum Veículo Encontrado
      </vs-alert>
    </div>
    <vs-collapse v-else type="border">
      <vs-collapse-item v-for="(veiculo, index) in listVeiculos" :key="index">
        <div slot="header">
          {{ veiculo.placa }}
          <vs-chip class="mr-4" :color="getStatusColor(veiculo.Status)">
            {{ veiculo.Status }}
          </vs-chip>
        </div>
        <div>
          <VeiculoCard :dadosEvento="veiculo" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vs-card>
</template>

<script>
import VeiculoCard from './../../shared/components/card/VeiculoCard.vue';

export default {
  props: ['listVeiculos'],
  components: {
    VeiculoCard,
  },
  methods: {
    getStatusColor(data) {
      if (data == 'ATIVO') return 'success';
      return 'warning';
    },
  },
};
</script>
